export const emailRegExp =
  // eslint-disable-next-line no-useless-escape
  /^[a-zA-Z0-9\+\.\_\%\-\+]{1,256}\@[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}(?:\.[a-zA-Z0-9][a-zA-Z0-9\-]{0,25})+$/;
// eslint-disable-next-line no-useless-escape
export const onlyNumbersReg = /^\d+$/;
// eslint-disable-next-line no-useless-escape
export const onlyCharacters = /^[A-Za-z]+$/;
// eslint-disable-next-line no-useless-escape
export const onlyCharactersName = /^((?:[A-Za-z]+ ?){1,3})$/;

export const passwordRegex =
  // eslint-disable-next-line no-useless-escape
  /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.\[\]{}()?"!@#%&\/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.\[\]{}()?"!@#%&\/\\,><':;|_~`=+\- ]{8,256}$/;
